import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import matchingReducer from './matchingSlice';
import registrationReducer from './registrationSlice';
import userProfileReducer from "../../redux/slices/userProfileSlice";
import appConfigReducer from './appConfigSlice';
import chatReducer from '../chatSlice';
import managerCenterAccessReducer from './managerCenterAccessSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  matching: matchingReducer,
  registration: registrationReducer,
  userProfile: userProfileReducer,
  appConfig: appConfigReducer,
  chat: chatReducer,
  managerCenterAccess: managerCenterAccessReducer,
});

export default rootReducer;
